<template>
  <v-layout wrap>
    <v-flex xs12 mb-2>
      <div class="caption pb-1 opacity-54">{{ fieldLabel }}</div>
      <a v-if="href" :href="href" target="_blank" rel="noopener noreferrer">{{ href }}</a>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: "url-field",
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    }
  },
  computed: {
    fieldLabel() {
      if (this.field && this.field.display_name) return this.field.display_name
      if (this.field && this.field.name) return Helpers.capitalizeRemoveUnderscores(this.field.name)
      return ""
    },
    href() {
      const value = this.data ? String(this.data).trim() : ""
      if (value.indexOf("https://") !== 0) return ""
      return value
    }
  }
}
</script>
